import React from "react";
import { useQuery, gql } from "@apollo/client";
import { Table, Row, Col, Label } from "reactstrap";
import DatetimeRenderer from "../../Material/DatetimeRenderer";
import Loader from "../../Material/Loader";
import Skeleton from "react-loading-skeleton";

const INCIDENT_HISTORY_QUERY = gql`
  query IncidentHistory($incidentId: ID!) {
    incident(incidentId: $incidentId) {
        id
        history { 
            date 
            user 
            comment 
        }  
    }
}`;

const historyTableHeader = [
    { id: "ID", name: "ID", colspan: 1 },
    { id: "date", name: "Date", colspan: 3 },
    { id: "user", name: "User", colspan: 2 },
    { id: "comment", name: "Comment", colspan: 6 },
]

const HistoryTab = ({ incidentId, history }) => {
    const { data, loading } = useQuery(INCIDENT_HISTORY_QUERY, {
        variables: { incidentId },
        skip: !incidentId || !!history,
    });

    let incidentHistory = history;
    if (!history && incidentId) {
        if (loading) return [...Array(5)].map((_, ridx) => (
            <Row key={ridx}>{[...Array(4)].map((_, cidx) => (<Col key={cidx}><Skeleton height={20} /></Col>))}</Row>
        ))
        const incident = data?.incident;
        if (!incident) return null;
        incidentHistory = incident.history;
    }


    return (
        <Table>
            <Row>
                {historyTableHeader.map(col => (
                    <Col key={col.id} xs={col.colspan}>
                        <Label style={{ fontWeight: 600 }}>{col.name}</Label>
                    </Col>
                ))}
            </Row>
            {Array.isArray(incidentHistory) && incidentHistory.length > 0 ? (
                incidentHistory.map((h, idx) => (
                    <Row key={idx}>
                        <Col xs={1}> {idx + 1}</Col>
                        <Col xs={3}><DatetimeRenderer datetime={h.date} /></Col>
                        <Col xs={2}>{h.user}</Col>
                        <Col xs={6}>{h.comment}</Col>
                    </Row>
                ))
            ) : (
                <Row><Col>No history available</Col></Row>
            )}
        </Table>
    );
};

export default HistoryTab;